/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Essentals

*/

import $ from 'jquery';


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

NPM Packages

*/

import 'lazysizes/plugins/print/ls.print'; // needs to be BEFORE the main script
import 'lazysizes';


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

allink CORE (NPM package)

===

These modules provide core functionality.

Note: Should you need a customzied project specific version of one of
the following modules:

Head over to the 'allink-core-static' repo, comment out the module below,
download the latest version and place it in the ./modules folder.

*/

import 'allink-core-static/js/modules/ajax-form';
import 'allink-core-static/js/modules/bootstrap-select';
import 'allink-core-static/js/modules/btn-ajax-loader';
import 'allink-core-static/js/modules/contact-form';
import 'allink-core-static/js/modules/datepicker';
import 'allink-core-static/js/modules/default-modal';
import 'allink-core-static/js/modules/djangocms-tweaks';
import 'allink-core-static/js/modules/expandable';
import 'allink-core-static/js/modules/feature-detection';
import 'allink-core-static/js/modules/form';
import 'allink-core-static/js/modules/form-modal';
import 'allink-core-static/js/modules/form-validation';
import 'allink-core-static/js/modules/full-height';
import 'allink-core-static/js/modules/image-modal';
import 'allink-core-static/js/modules/lazysizes';
import 'allink-core-static/js/modules/masonry';
import 'allink-core-static/js/modules/pagechooser';
import 'allink-core-static/js/modules/seo';
import 'allink-core-static/js/modules/site-overlay';
import 'allink-core-static/js/modules/smooth-scroll';
import 'allink-core-static/js/modules/softpage';
import 'allink-core-static/js/modules/table';
import 'allink-core-static/js/modules/tingle';
import 'allink-core-static/js/modules/to-the-top';
import 'allink-core-static/js/modules/video';
import 'allink-core-static/js/modules/viewport-dimensions';
import 'allink-core-static/js/modules/ajax-load-plugins';

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Custom Scripts

*/

import './modules/ajax-load-items';
import './modules/header';
import './modules/map';
import './modules/navigation';
import './modules/onscreen';
import './modules/parallax';
import './modules/swiper';
import './modules/to-the-top';
import './modules/tooltip';
import './modules/sticky';
import './modules/localize';
import './modules/google-referer';
import './modules/references';
// SVG animations
import './modules/scheme-animation';
import './modules/value-animation';
import './modules/electricity-animation';
import './modules/seo-accordion';


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

Cleanup bootstrap-select

*/

function cleanupBootstrapSelect() {
    $('.bootstrap-select').on('loaded.bs.select',function(){
        let $dropdown = $(this);
        $dropdown.find('.dropdown-toggle').removeClass('btn-default');
    });
}


$(function() {


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Initialize CMS-Plugins after Ajax-Request

    */

    if (typeof CMS !== 'undefined') {
        $(window).on('ajaxLoadItems:success', function(event){
            CMS.Plugin._initializeTree();
        });
    }


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * *

    Tweak bootstrap-select and get rid of the btn-default class

    */

    cleanupBootstrapSelect();

    $(window).on('form-modal:opened ajaxForm:success',function(){
        cleanupBootstrapSelect();
    });

});



// WEBPACK FOOTER //
// ./static/js/app.js